import React from 'react';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '../../../components';

import './style.scss';

const ParagraphQuestionsOverview = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <div id={paragraphKey} className="Paragraph QuestionsOverview">
      <Container>
        <div className="QuestionsOverview__wrapper">
          { (title || body) && (
            <div className="QuestionsOverview__header">
              { title && (
                <h2 className="QuestionsOverview__title">{ title }</h2>
              )}
              { body && (
                <WysiwygField
                  property="schema:text"
                  className="QuestionsOverview__body"
                  html={body}
                />
              )}
            </div>
          )}
          {
            entity.getIn(['field_paragraphs'], List()).map((item) => {
              const paragraphId = item.get('target_id');
              const paragraph = item.get('entity');
              return (
                <div key={paragraphId} className="Paragraph QuestionsOverviewItem">
                  <Paragraph entity={paragraph} id={paragraphId} key={paragraphId} />
                </div>
              );
            })
          }
        </div>
      </Container>
    </div>
  );
};

export default ParagraphQuestionsOverview;
